module.exports = __webpack_public_path__ + "static/img/tow.af6672bc.gif";